<template>
    <div class="batch-notify-comp">
        <div class="left table-list">
            <div class="mask"></div>
            <div v-if="contractCid.length" class="selected-tips">
                <div class="wording">
                    已選取 {{contractCid.length}} 個房源
                </div>
            </div>
            <div v-if="this.filterTag.length" class="filter-tips">
                <span class="result">
                    {{filterByWord.length}} 個結果
                </span>
                <span class="item" v-for="(item, index) in this.filterTag" :key="index">
                    {{item}}
                </span>
            </div>
            <div class="table-list-title">
                <span class="checkbox">
                    <checkbox v-model="checkboxStatus.checkboxAll"  :isPropChecked="checkboxStatus.checkboxAll"></checkbox>
                </span>
                <span class="address">地址</span>
                <span class="bill">下期帳單</span>
                <span class="rent">租金</span>
                <span class="auto-rent" v-if="bizAuth.autoCollectRentSetting.hasRight">自動收租</span>
                <span class="auto-notify" v-if="bizAuth.autoCollectRentSetting.hasRight">收租提醒</span>
            </div>
            <div class="table-list-body">
                <div v-if="isLoading" class="filter-empty">
                    <table-loading />
                </div>
                <div v-else-if="filterByWord.length == 0 && batchNotifyList.length != 0" class="filter-empty">
                    <span>0 個搜尋結果</span>
                    <!-- <button class="default-button" @click="setFilterDefault">清除篩選</button> -->
                </div>
                <div v-else-if="batchNotifyList.length == 0" class="is-empty">0 筆資料</div>
                <ul v-else>
                    <li v-for="(list,index) in filterByWord" :key="index" @mouseenter="selectedId = list.contractCid, selectedIndex = index">
                        <span class="checkbox" @click="clearSuccessFlag">
                            <checkbox :val="list.contractCid" v-model="contractCid" :isPropChecked="checkboxStatus.checkboxAll || checkboxStatus.forceUpdate"></checkbox>
                        </span>
                        <span class="address to-dot">{{list.address}}</span>
                        <span class="bill">{{list.periodStartDate}}~{{list.periodEndDate}}</span>
                        <span class="rent">{{toCurrency(list.rentMonthly)}}</span>
                        <span class="auto-rent" v-if="bizAuth.autoCollectRentSetting.hasRight">
                            <rent-switch v-model="autoCreateList[index].autoCreate" :dValue="list.autoCreateBill"></rent-switch>
                        </span>
                        <span class="auto-notify" v-if="bizAuth.collectRentNotify.hasRight">
                            <rent-switch v-model="autoSendList[index].autoSend" :dValue="list.sendRentNotify"></rent-switch>
                        </span>
                        <span  class="success-alarm" v-if="successFlag[index]">
                            <img src="@/assets/img/icon/success_done.svg" alt="">
                        </span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="right">
            <batch-notify-filter></batch-notify-filter>
        </div>
    </div>
</template>
<script>
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';
import batchNotifyFilter from '@/components/bussiness/mgtCategory/leaseMgt/batchNotify/batchNotifyFilter.vue';
import RentSwitch from '@/components/widge/RentSwitch.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            checkboxStatus: {
                checkboxAll: false,
                forceUpdate: null
            },
            contractCid: [],
            successFlag: [],
            autoCreateList: [],
            autoSendList: [],
            selectedId: null,
            selectedIndex: null,
            isLoading: true
        }
    },
    created () {
        this.$store.dispatch('getBizBatchNotifyList')
        .then(()=>{
            this.isLoading = false
        })
    },
    watch: {
        filterByWord: {
            handler: function (val) {
                this.setEditList(val)
            },
            immediate: true
        } ,
        checkboxStatus: {
            handler: function (val) {
                console.log(val)
                setTimeout(()=>{
                    this.$store.dispatch('setBizBatchNotifyCheckboxStatus', val)
                },500)
            },
            deep: true
        },
        contractCid: {
            handler: function (val) {
                this.$store.dispatch('setBizBatchNotifySeletedHouse', val)
                if(val.length === 0){
                    this.checkboxStatus.checkboxAll = false
                }else if(this.filterByWord.length === val.length){
                    this.checkboxStatus.checkboxAll = true
                }
            },
            deep: true
        },
        filterQueryUpdate: function () {
            this.clearCheckbox()
        },
        'checkboxStatus.checkboxAll': function (val) {
            this.clearSuccessFlag()
            let list = this.filterByWord
            if(val){
                for (let i = 0; i < list.length; i++) {
                    const element = list[i];
                    if(!this.contractCid.includes(element.contractCid)){
                        this.contractCid.push(element.contractCid)
                    }
                }
            }else{
                this.contractCid = []
            }
        },
        successList: function (val) {     
            this.clearCheckbox()
            for (let i = 0; i < this.filterByWord.length; i++) {
                const element = this.filterByWord[i];
                if(val.includes(this.filterByWord[i].contractCid)){
                    this.successFlag[i] = true
                }
            }
        },
        autoCreateList: {
            handler: function (val) {
                this.$store.dispatch('updateBizSendRent', val)
                .then(()=>{
                    this.$store.commit('batchNotify/set_success_list', [this.selectedId])
                    // this.$store.dispatch('setAlarmStatus', {status: true,title: '成功設定自動收租',type: 'success'})
                })
            },
            deep: true
        },
        autoSendList: {
            handler: function (val) {
                this.$store.dispatch('updateBizNotify', val)
                .then(()=>{
                    this.$store.commit('batchNotify/set_success_list', [this.selectedId])
                    // this.$store.dispatch('setAlarmStatus', {status: true,title: '成功設定自動提醒',type: 'success'})
                })
            },
            deep: true
        }
    },
    methods: {
        setEditList: function (list) {
            this.autoSendList = []
            this.autoCreateList = []
            for (let index = 0; index < list.length; index++) {
                const element = list[index];
                this.autoSendList.push(
                    {
                        "contractCid": element.contractCid,
                        "autoSend" : element.sendRentNotify
                    }
                )
                this.autoCreateList.push(
                    {
                        "contractCid": element.contractCid,
                        "autoCreate" : element.autoCreateBill,
                    }
                )
                
            }
        },
        clearCheckbox: function () {
            this.checkboxStatus.forceUpdate = false
            this.contractCid = []
            setTimeout(()=>{
                this.checkboxStatus.forceUpdate = null
            }, 500)
        },
        clearSuccessFlag: function () {
            this.successFlag = []
        }
    },
    computed: {
        filterByCounty: function () {
            return this.batchNotifyList.filter((item) => {
                if(this.filterQuery.county){
                    if(item.city.includes(this.filterQuery.county) == true){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByDistrict: function () {
            return this.filterByCounty.filter((item) => {
                if( this.filterQuery.district){
                    if(item.district.includes(this.filterQuery.district) == true){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByHouseType: function () {
            return this.filterByDistrict.filter((item) => {
                if( this.filterQuery.houseType ){
                    if( this.filterQuery.houseType == item.houseType ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByGroup: function () {
            return this.filterByHouseType.filter((item) => {
                if(this.filterQuery.group){
                    if(item.groupName == this.filterQuery.group ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.member){
                    if(item.agentName == this.filterQuery.member ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterBySales.filter((item) => {
                this.filterQueryUpdate
                if( this.filterQuery.word ){
                    if( item.address.includes(this.filterQuery.word) ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterTag: function () {
            let filterTag = []
            let index = 0
            for( var item in this.filterQuery ){
                let filterValue = this.filterQuery[item]
                if(filterValue && item != 'countyId'){
                    filterValue = this.transFilterTagContent(item, filterValue)
                    filterTag[index] = this.transFilterTagTitle(item)+'：'+filterValue
                    index++
                }
            }
            return filterTag
            
        },
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            batchNotifyList: 'GET_BIZ_BATCH_NOTIFY_LIST',
            filterQuery: 'GET_BIZ_BATCH_NOTIFY_FILTER_QUERY',
            filterQueryUpdate: 'GET_BIZ_BATCH_NOTIFY_FILTER_QUERY_UPDATE',
            successList: 'GET_BIZ_BATCH_NOTIFY_SUCCESS_LIST'
            // contractCid: 'GET_BIZ_BATCH_PUBLISH_SELECTED_HOUSE_CID',
            // policyCid: 'GET_BIZ_BATCH_PUBLISH_SELECTED_PUBLISH_CID'
        })
    },
    components: {
        Checkbox,
        batchNotifyFilter,
        RentSwitch,
        tableLoading
    }
}
</script>
<style lang="scss">
    .batch-notify-comp{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .table-list{
            width: 850px;
            .table-list-title{
                padding: 16px;
            }
            .table-list-body ul li{
                padding: 16px;
            }
            .checkbox{
                width: 20px;
                margin-right: 16px;
            }
            .address{
                width: 220px;
                margin-right: 46px;
            }
            .bill{
                width: 160px;
                margin-right: 45px;
            }
            .rent{
                width: 51px;
                margin-right: 49px;
                text-align: right;
            }
            .auto-rent{
                width: 85px;
                margin-right: 27px;
            }
            .auto-notify{
                width: 85px;
            }
            .rent-switch{
                .rent-switch-item{
                    width: 40px;
                    height: 22px;
                    border-radius: 14px;
                    backdrop-filter: blur(6.7px);
                    box-shadow: 0 3px 13px 0 rgba(37, 38, 94, 0.1);
                    &::before{
                        top: 0;
                        left: 0px;
                        width: 40px;
                        height: 23px;
                    }
                    &::after{
                        top: 3px;
                        left: 3px;
                        width: 17px;
                        height: 17px;
                    }
                    &.rent-switch-on{
                        &::after{
                            left: 0px;
                        }
                    }
                }
            }
            .success-alarm{
                position: absolute;
                right: 20px;
            }
            .to-dot{
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
            }
        }
    }
    .page-setting.fixed .batch-notify-comp .table-list .table-list-title {
        position: relative;
        top: unset;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/leaseMgt/batchNotify/batchNotifyComp.vue